import React from "react";

import { Icon } from "@wfp/ui";
import { iconEdit } from "@wfp/icons";

/** Decide whether a column should by rendered as a checkbox */
export const IsBoolComponent = row => (
  <input type="checkbox" checked={row.value} disabled />
);

const columnsGenerator = (setItem, canEdit) => [
  {
    Header: "Name",
    accessor: "name"
  },
  {
    Header: "Code",
    accessor: "code"
  },
  {
    Header: "Deprecated",
    accessor: "is_deprecated",
    Cell: IsBoolComponent
  },
  {
    Header: "",
    accessor: "id",
    /* eslint-disable */
    Cell: row =>
      canEdit ? (
        <Icon
          icon={iconEdit}
          width="19"
          height="19"
          description="Edit item"
          onClick={() => setItem(row.value)}
          style={{ cursor: "pointer" }}
        />
      ) : (
        <Icon
          icon={iconEdit}
          width="19"
          height="19"
          description="Edit item"
          style={{ cursor: "pointer", opacity: "0.5" }}
        />
      ),
    /* eslint-enable */
    resizable: false,
    sortable: false,
    width: 50,
    style: { justifyContent: "center" }
  }
];

export default columnsGenerator;
